import { render } from "./Embed.vue?vue&type=template&id=442acb83&scoped=true"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"

import "./Embed.vue?vue&type=style&index=0&id=442acb83&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442acb83"]])

export default __exports__